'use client'

import { useState } from 'react'
import Image from 'next/image'
import { cn } from '@desoutter/uikit'
import { ClippedImage } from '@desoutter/uikit'
import VideoModal from './VideoModal'
import { MediaItem, MediaType } from '@/types/medias'

type ImageViewerProps = {
	medias: MediaItem[]
}

export default function ImageViewer({ medias }: ImageViewerProps) {
	const [currentIndex, setCurrentIndex] = useState(0)
	const [isVideoModalOpen, setIsVideoModalOpen] = useState(false)
	const [videoToPlay, setVideoToPlay] = useState<MediaItem | null>(null)

	const currentItem = medias[currentIndex]

	const handleVideoClick = (videoItem: MediaItem) => {
		setVideoToPlay(videoItem)
		setIsVideoModalOpen(true)
	}

	const closeVideoModal = () => {
		setIsVideoModalOpen(false)
		setVideoToPlay(null)
	}

	return currentItem ? (
		<div className="w-full lg:w-[460px] 2xl:w-[600px]">
			<div className="relative mt-8">
				<div className="relative">
					<ClippedImage
						key={currentItem.id}
						src={new URL(
							currentItem.src +
								'/jcr:content/renditions/cq5dam.web.800.800.jpeg',
						).toString()}
						style={{ objectFit: 'cover', width: '100%' }}
						width={800}
						height={800}
						className="xl:w-full aspect-square rounded-2xl"
						alt={`image-${currentItem.id.toString()}`}
					/>
				</div>
			</div>
			{medias.length > 0 && (
				<div className="flex mt-4 mb-8 gap-1 md:gap-4 flex-wrap">
					{medias.map((item, i) => (
						<div
							className="relative h-20 min-w-20 cursor-pointer"
							onClick={() => {
								if (item.type === MediaType.VIDEO) {
									handleVideoClick(item)
								} else {
									setCurrentIndex(i)
								}
							}}
							key={item.id}
						>
							{item.type === MediaType.VIDEO ? (
								<div className="relative">
									<Image
										src={item.src}
										style={{
											objectFit: 'cover',
											height: '80px',
											width: '80px',
										}}
										className={cn(
											'relative rounded-2xl',
											currentItem.id === item.id && 'border border-red-300',
										)}
										width="80"
										height="80"
										alt={item.title || 'Video thumbnail'}
									/>
									{/* Play button overlay */}
									<div className="absolute inset-0 flex items-center justify-center">
										<div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
											<div className="w-0 h-0 border-l-[8px] border-l-white border-t-[5px] border-t-transparent border-b-[5px] border-b-transparent ml-0.5"></div>
										</div>
									</div>
								</div>
							) : (
								<Image
									loader={() => {
										const url = new URL(
											item.src +
												'/jcr:content/renditions/cq5dam.web.400.400.jpeg',
										)
										return url.toString()
									}}
									style={{ objectFit: 'cover', height: '80px', width: '80px' }}
									src="/images/image-placeholder.svg"
									className={cn(
										'relative rounded-2xl',
										currentItem.id === item.id && 'border border-red-300',
									)}
									width="80"
									height="80"
									alt=""
								/>
							)}
						</div>
					))}
				</div>
			)}
			<VideoModal
				isOpen={isVideoModalOpen}
				videoItem={videoToPlay}
				onClose={closeVideoModal}
			/>
		</div>
	) : (
		<Image
			src={'/images/image-placeholder.svg'}
			width={800}
			height={800}
			className="max-lg:p-16 pt-0 rounded-2xl"
			alt=""
		/>
	)
}
